import React from "react"
import FullCalendar from '@fullcalendar/react'
import '@fullcalendar/resource-timeline/main.css'; // Import the base FullCalendar styles
import '../../../scss/modules/_page.scss'
import {observer} from "mobx-react";
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import {toggleDrawer} from "../../helpers/helpers";
import Drawer from "../Drawer/Drawer";
import translate from "../Translate";
import IncidentForm from "../Sessions/IncidentForm";
import moment from 'moment'
import ReactDatePicker from "react-datepicker";


const AppointmentTimeline = observer(class AppointmentTimeline extends React.Component {

  constructor() {
    super();
    this.state = {
      drawerOpen: false,
      drawerContent: null,
      session:null,
      dateSelected: null,
      showDatePicker: false
    }
    this.completeIncident = this.completeIncident.bind(this);
    this.refreshEvents = this.refreshEvents.bind(this);
    this.calendarRef = React.createRef();
  }


  completeIncident() {
    const { ManagerStore, SessionStore } = this.props.store;
    ManagerStore.reportIncident = false;
    SessionStore.showToaster("Incident Saved", 'success');
  }



  componentDidMount() {
    this.refreshEvents();
    setInterval(this.refreshEvents, 60000);
  }

  refreshEvents() {
    const {ScheduleStore} = this.props.store;
    const { dateSelected } = this.state;

    if (dateSelected) {
      const startTime = moment(dateSelected).startOf('day').format('YYYY-MM-DDTHH:mm:ssZ');
      const endTime = moment(dateSelected).endOf('day').format('YYYY-MM-DDTHH:mm:ssZ');

      ScheduleStore.getTimelineEvents(startTime, endTime);
    } else {
      ScheduleStore.getTimelineEvents();
    }

    ScheduleStore.getTimelineResources();
  }

  datesUpdated = (dateInfo) => {
    const {ScheduleStore} = this.props.store;
    ScheduleStore.getTimelineEvents(dateInfo.startStr, dateInfo.endStr);
    this.setState({dateSelected: dateInfo.startStr});
  }

  handleSelectedDate = (newDate) => {
    const calendarApi = this.calendarRef.current.getApi();
    calendarApi.gotoDate(newDate);
    this.setState({showDatePicker: false})
  }

  render() {
  const {ScheduleStore, ManagerStore} = this.props.store;
  const { showDatePicker } = this.state;

    const customButtons = {
        selectDate:{
          text: "Select a date",
          click: () => {
            this.setState({showDatePicker: true})
          }
        }
    };

  return (
        <div className="appointment-timeline">
          <main tabIndex="0" id="main-content" className="page">
            <h1>Appointment Timeline</h1>
            {showDatePicker &&
              <div className='react-datepicker--wrap'>
                <ReactDatePicker
                  inline
                  onChange={this.handleSelectedDate}
                  onClickOutside={() => this.setState({showDatePicker: false})}
                />
              </div>
            }
            <FullCalendar
                schedulerLicenseKey="0832097408-fcs-1687374553"
                ref={this.calendarRef}
                aspectRatio={1.6}
                slotDuration={'00:15'}
                timeZone='local'
                nowIndicator={true}
                resourceAreaHeaderContent={"Locations"}
                plugins={[resourceTimelinePlugin]}
                initialView='resourceTimelineDay'
                events={ScheduleStore.timelineEvents}
                resources={ScheduleStore.timelineResources}
                resourceGroupField={'location'}
                resourceOrder={''}
                editable={true}
                datesSet={(dateInfo) => this.datesUpdated(dateInfo)}
                eventMouseEnter={(info) => {
                  /*
                  TODO: Implement a sticky popup instead of a tooltip, trying to force our styles over the Full calendar styles is not going well
                  const tooltip = document.createElement('div');
                  tooltip.textContent = `Name: ${info.event.title} \n Appointment Start: ${moment.utc(info.event.start).format('HH:mm')} \n Appointment End: ${moment.utc(info.event.end).format('HH:mm')} \n Exam Name: \n Course `; // Set the tooltip text

                  // Apply styling to the tooltip element
                  tooltip.classList.add('timeline-tooltip');
                  tooltip.addEventListener('mouseout', () => {
                    tooltip.remove();
                  });
                  info.el.appendChild(tooltip);

                   */
                }}
                eventClick={async (info) => {
                  const extendedProps = info.event.extendedProps
                  const response = await ManagerStore.getExamSession(extendedProps.install.sid, extendedProps.exam.sid, extendedProps.session.sid, 'uggg', this, true);
                  this.setState({session: response})
                  toggleDrawer(null, this, 'SessionDetail')
                }}
                customButtons={customButtons}


            headerToolbar={{
            left: 'prev,next today',
            center: 'title',
            right: 'selectDate'
            }}

            />
          </main>
          <Drawer
              sessionSid={this.state.session ? this.state.session.sid : null}
              content={this.state.drawerContent}
              isOpen={this.state.drawerOpen}
              refreshEvents={this.refreshEvents}
              handleSelectedDate={this.handleSelectedDate}
              parent={this}
              timeline={true}
              appointmentTimeline={true}
              {...this.props}
          />

          <div className={`session-interact  ${ManagerStore.reportIncident ? 'active' : ''}`}>
            <div className="panel--brief">
              <h2>Report Incident</h2>

              {ManagerStore.reportIncident &&
              <IncidentForm
                  installSid={this.props.store.ScheduleStore.session.installSid}
                  examSid={this.props.store.ScheduleStore.session.examSid}
                  complete={this.completeIncident}
                  {...this.props}
              />
              }

            </div>
          </div>
        </div>
    );
  }
}); export default translate('AppointmentTimeline')(AppointmentTimeline);




// WEBPACK FOOTER //
// ./src/app/components/Calendar/AppointmentTimeline.js